import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

import { StateService } from './state.service';

@Injectable()
export class ErrorHandlingService {
  constructor(private _stateService: StateService) {}

  /** Http error handler. The 'catch' statement seems to be optional when calling an http service.
   * The error will be passed to the calling component and should be handled there.
   * Use this method for generic error handling.
   */
  catchThrowError(error: any) {
    // Add some handling here?

    return throwError(error);
  }

  // Notify UI to display a friendly message
  friendlyErrorHandler(isError: boolean) {
    this._stateService.hasError(isError);
  }
}
